import { useMemo } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import attributeDisplayUtility from '@atom/utilities/attributeDisplayUtility';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { inspectionDataOrder } from './collinsMpcConstants';
import { getAttributeDataRows } from './collinsMpcUtilities';

import classes from './collinsMpcPdfReport.module.css';

interface Props {
  workOrder: any;
  workOrderAsset: any;
}

const InspectionData = ({ workOrder, workOrderAsset }: Props) => {
  const data = getAttributeDataRows(
    workOrderAsset?.attributes,
    inspectionDataOrder,
  );

  const mainPhoto = useMemo(() => {
    if (!isNilOrEmpty(workOrder)) {
      return R.find(R.propEq(workOrder?.mainPhotoId, 'id'))(
        workOrder?.media?.media,
      );
    }

    return {};
  }, [workOrder]);

  const photoStyle = {
    backgroundImage: `url('${FILES_ENDPOINT}/${R.pathOr('', ['fileId'], mainPhoto)}_1440')`,
  };

  return (
    <div className={clsx(classes.sectionBox, classes.noMargin)}>
      <div className={classes.sectionTitle}>Inspection Data</div>
      <div className={classes.inspectionContent}>
        <div className={classes.leftBox}>
          {data.map(attribute => {
            return (
              <div className={classes.dataRow} key={attribute?.id}>
                <div className={classes.dataTitle}>{`${attribute?.name}:`}</div>
                <div className={classes.dataContent}>
                  {attributeDisplayUtility.display(
                    attribute.value,
                    attribute.dataType,
                    attribute.unit,
                    !!attribute.changeId,
                    attribute.newValue,
                    attribute.thousandsSeparator,
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div className={classes.photoBox}>
          {!isNilOrEmpty(mainPhoto) && (
            <div className={classes.photo} style={photoStyle} />
          )}
        </div>
      </div>
    </div>
  );
};

export default InspectionData;
